export { LandingPageMobile } from "./LandingPageMobile";
